import React, { useState, useEffect } from "react";
import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion'
import bin from './bin.png';
import { BlockPicker } from 'react-color';


function Region(props) {

    const [newProps, setNewProps] = useState(null);
    const [showColor, setShowColor] = useState(false);
    const colores = ["#bcbdc0", "#e89b37", "#4d8dd7", '#D9E3F0', '#F47373', '#37D67A', '#2CCCE4', '#dce775', '#ff8a65', '#ba68c8']

    if (props !== newProps) {
        setNewProps(props);
    }

    let tipo, titulo
    if (props.region.tipo == "dept") {
        tipo = "dept"
        titulo = props.region.departamento
    }
    else if (props.region.tipo == "totalDept") {
        tipo = "dept"
        titulo = "Departamentos"
    }
    else if (props.region.tipo == "totalMun") {
        tipo = "dept"
        titulo = "Municipios de " + props.region.departamento
    }
    else if (props.region.tipo == "mun") {
        tipo = "dept"
        titulo = props.region.municipio + " - " + props.region.departamento
    }
    else if (props.region.tipo == "PDET") {
        tipo = "PDET"
        titulo = props.region.departamento
    }
    else if (props.region.tipo == "totalPDET") {
        tipo = "PDET"
        titulo = "Todos los PDET"
    }

    const opcionesAlcance = [
        { value: 'dept', label: 'Deprtamental' },
        { value: 'PDET', label: 'PDET' },
    ];

    function ajustarMunicipio(newValue) {
        props.fun.cambiarMunicipioRegion(newValue.label, props.region.id)
    }

    function ajustarDepartamento(newValue) {
        props.fun.cambiarDepartamentoRegion(newValue.label, props.region.id)
    }

    function ajustarTipo(newValue) {
        props.fun.cambiarTipoRegion(newValue.value, props.region.id)
    }

    function eliminar() {
        props.fun.eliminarRegion(props.region.id)
    }


    function PDET() {
        let opciones = props.opciones.PDET
        return (
            <div className="col-md-12 col-sm-12 col-xs-12">
                <label className="form-label">PDET</label>
                <Select
                    bsPrefix="form-control-sm"
                    options={opciones}
                    closeMenuOnSelect={true}
                    onChange={ajustarDepartamento}
                    value={opciones.find(item => item.label == props.region.departamento)}
                    theme={props.darkMode ? (theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary: '#646a70',
                          primary25: '#444a50',
                          primary50: '#545a60',
                          neutral0: '#343a40',
                          neutral80: '#fff',
                          neutral100: '#fff',
                        },
                      }): null}
                />
            </div>
        )
    }

    function depto() {
        let opciones = props.opciones.dept
        return (
            <div className="col-md-12 col-sm-12 col-xs-12">
                <label className="form-label">Departamento</label>
                <Select
                    bsPrefix="form-control-sm"
                    options={opciones}
                    closeMenuOnSelect={true}
                    onChange={ajustarDepartamento}
                    value={opciones.find(item => item.label == props.region.departamento)}
                    theme={props.darkMode ? (theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary: '#646a70',
                          primary25: '#444a50',
                          primary50: '#545a60',
                          neutral0: '#343a40',
                          neutral80: '#fff',
                          neutral100: '#fff',
                        },
                      }): null}
                />
            </div>
        )
    }

    function municipal() {
        let opciones = props.opciones.mun.filter(item => item.depto == props.region.departamento)
        return (
            <div className="col-md-12 col-sm-12 col-xs-12">
                <label className="form-label">Municipio</label>
                <Select
                    bsPrefix="form-control-sm"
                    options={opciones}
                    closeMenuOnSelect={true}
                    onChange={ajustarMunicipio}
                    value={opciones.find(item => item.label == props.region.municipio)}
                    theme={props.darkMode ? (theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary: '#646a70',
                          primary25: '#444a50',
                          primary50: '#545a60',
                          neutral0: '#343a40',
                          neutral80: '#fff',
                          neutral100: '#fff',
                        },
                      }): null}
                />
            </div>
        )
    }

    function mostrarMunicipal() {
        return (
            <>
                {depto()}
                {municipal()}
            </>
        )
    }

    function mostrarTipo() {
        if (tipo == "PDET") {
            return PDET()
        }
        else if (props.region.tipo == "totalDept") {
            return depto()
        }
        else {
            return mostrarMunicipal()
        }
    }

    function handleClickColor() {
        setShowColor(!showColor)
    };

    function handleCloseColor() {
        setShowColor(false)
    };

    function handleChangeColor(color) {
        props.fun.cambiarColorRegion(color.hex, props.region.id)
    };

    return (

        <Accordion.Item eventKey={props.region.id}>
            <Accordion.Header >
                <strong>{props.region.id + 1}.&nbsp;</strong> {titulo}
            </Accordion.Header>
            <Accordion.Body>
                <form className="row g-3 px-2 py-2">
                    <div className="col-md-4 col-sm-4 col-xs-4 col-6 mt-4">
                        <label className="form-label">Color</label>
                    </div>
                    <div className="col-md-8 col-sm-8 col-xs-6 col-6 mt-4">
                        <div style={{
                            padding: '5px',
                            background: '#fff',
                            borderRadius: '1px',
                            boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                            display: 'inline-block',
                            cursor: 'pointer',
                        }} onClick={handleClickColor}>
                            <div style={{
                                width: '50px',
                                height: '14px',
                                borderRadius: '2px',
                                background: props.region.color,
                            }} />
                        </div>
                        {showColor ? <div style={{
                            position: 'absolute',
                            zIndex: '2',
                        }}>
                            <div style={{
                                position: 'fixed',
                                top: '0px',
                                right: '0px',
                                bottom: '0px',
                                left: '0px',
                            }} onClick={handleCloseColor} />
                            <BlockPicker color={props.region.color} onChange={handleChangeColor} triangle="hide" colors={colores} />
                        </div> : null}
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <label className="form-label">Alcance</label>
                        <Select
                            bsPrefix="form-control-sm"
                            options={opcionesAlcance}
                            closeMenuOnSelect={true}
                            onChange={ajustarTipo}
                            defaultValue={opcionesAlcance.find(item => item.value == tipo)}
                            theme={props.darkMode ? (theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary: '#646a70',
                                  primary25: '#444a50',
                                  primary50: '#545a60',
                                  neutral0: '#343a40',
                                  neutral80: '#fff',
                                  neutral100: '#fff',
                                },
                              }): null}
                        />
                    </div>
                    {mostrarTipo()}
                </form>
                <div className="text-center pt-1 pb-2">
                    <button className="btn btn-default" onClick={eliminar}>
                        <img src={bin} className="rounded mx-auto d-block plus-icon" alt="..."></img>
                    </button >
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );

}

export default Region;